





























import {Component, Vue} from 'vue-property-decorator';
import {TranslateResult} from 'vue-i18n';
import SignpostCard from '@/components/SignpostCard.vue';

@Component({
	components: {
		'v-signpost-card': SignpostCard
	}
})
export default class Signpost extends Vue {

	get signpostCards(): TranslateResult {
		return this.$t('pricing.tarifs');
	}

}
